"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const constants_1 = require("../../../../constants/constants");
const eventConstants_1 = require("../../../../constants/eventConstants");
const useWebDesktopDesign_1 = __importDefault(require("../../../../hooks/useWebDesktopDesign"));
const colors_1 = __importDefault(require("../../../../styles/colors"));
const styles_1 = __importDefault(require("../../../../styles/styles"));
const button_1 = __importDefault(require("../../../button/button"));
const dialog_1 = __importDefault(require("../../../dialog/dialog"));
const icon_1 = __importDefault(require("../../../icon/icon"));
const pressable_1 = __importDefault(require("../../../pressable/pressable"));
const timer_1 = __importDefault(require("./timer/timer"));
const CallConfirmed = ({ contact, endCall, isOnHold, isMuted, holdCallHandler, muteCallHandler, startDatetime, }) => {
    const isDesktop = useWebDesktopDesign_1.default();
    const iconNotFilledStyle = [styles_1.default.borderWidthOne, styles_1.default.blueBorder];
    const [confirmEndCallDialogActive, setConfirmEndCallDialogActive] = react_1.useState(false);
    const confirmEndCallButtonActions = (react_1.default.createElement(react_native_1.View, { style: isDesktop ? [styles_1.default.flexDirectionRow] : [styles_1.default.flexOne] },
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginFive },
            react_1.default.createElement(button_1.default, { text: "Cancel", icon: free_solid_svg_icons_1.faStepBackward, onPress: () => {
                    setConfirmEndCallDialogActive(false);
                }, fill: true, eventName: eventConstants_1.CANCEL_ENDING_VOIP_CALL_PRESS })),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginFive },
            react_1.default.createElement(button_1.default, { text: "Confirm", icon: free_solid_svg_icons_1.faCheckCircle, onPress: () => {
                    setConfirmEndCallDialogActive(false);
                    endCall();
                }, eventName: eventConstants_1.CONFIRM_ENDING_VOIP_CALL_PRESS }))));
    return confirmEndCallDialogActive ? (react_1.default.createElement(react_native_1.View, { style: react_native_1.Platform.OS === constants_1.WEB_TAG ? [] : styles_1.default.allScreenMobile },
        react_1.default.createElement(dialog_1.default, { title: "End Call", text: "Are you sure you want to end this call?", action: confirmEndCallButtonActions, hideDialog: () => setConfirmEndCallDialogActive(false), visible: confirmEndCallDialogActive }))) : (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.greenLabel, styles_1.default.flexDirectionRow] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.marginTen] },
                react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlack }, contact)),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexOne, styles_1.default.alignCenterEnd, styles_1.default.marginTen] },
                react_1.default.createElement(timer_1.default, { datetimeStarted: startDatetime }))),
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.marginTen, styles_1.default.alignCenterCenter] },
            react_1.default.createElement(pressable_1.default, { style: [
                    styles_1.default.flexOne,
                    styles_1.default.marginTen,
                    styles_1.default.roundedIconContainer,
                    isMuted ? styles_1.default.blueBackground : iconNotFilledStyle,
                ], onPress: () => muteCallHandler(!isMuted), eventName: eventConstants_1.MUTE_VOIP_CALL_PRESS },
                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faMicrophone, color: isMuted ? colors_1.default.WHITE : colors_1.default.BLUE, size: 28 })),
            react_1.default.createElement(pressable_1.default, { style: [
                    styles_1.default.flexOne,
                    styles_1.default.marginTen,
                    styles_1.default.roundedIconContainer,
                    isOnHold ? styles_1.default.blueBackground : iconNotFilledStyle,
                ], onPress: () => holdCallHandler(!isOnHold), eventName: eventConstants_1.HOLD_VOIP_CALL_PRESS },
                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faPhoneSlash, color: isOnHold ? colors_1.default.WHITE : colors_1.default.BLUE, size: 28 })),
            react_1.default.createElement(pressable_1.default, { style: [
                    styles_1.default.flexOne,
                    styles_1.default.marginTen,
                    styles_1.default.roundedIconContainer,
                    styles_1.default.borderWidthOne,
                    styles_1.default.redBorder,
                ], onPress: () => setConfirmEndCallDialogActive(true), eventName: eventConstants_1.END_CALL_DIALOG_PRESS },
                react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faPhone, color: colors_1.default.RED, size: 28 })))));
};
exports.default = CallConfirmed;
